type related = {
  id: string
  kind: number
}

export type RelatedUserProps = {
  relatedUsers: related[]
  userID: string
}

export class RelatedUser {
  private readonly _relatedUsers: related[]
  private readonly _userID: string

  constructor(p: RelatedUserProps) {
    this._relatedUsers = p.relatedUsers
    this._userID = p.userID
  }

  get id(): string {
    return this._userID
  }

  get relatedUsers(): related[] {
    return this._relatedUsers
  }
}
